// extracted by mini-css-extract-plugin
export var header = "_tu-1";
export var maskBottom = "_tu-6";
export var maskMiddle = "_tu-7";
export var maskTop = "_tu-5";
export var root = "_tu-0";
export var scrollDownButton = "_tu-3";
export var scrollDownButtonHidden = "_tu-4";
export var viewport = "_tu-2";